/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/components/warenkorb-menu/app.warenkorb-menu.component.ts.
 */
import {Component, OnDestroy, OnInit} from '@angular/core';
import {AppWarenkorbService} from '../../services/app.warenkorb.service';
import {Subscription, skip} from 'rxjs';
import {Warenkorb} from '../../models/warenkorb';
import {Router} from '@angular/router';
import {AppLieferkundeService} from '../../services/app.lieferkunde.service';
import {Lieferkunde} from '../../models/lieferkunde';
import {AppMobileService} from '../../services/app.mobile.service';
import {AppEventService} from '../../services/app.event.service';

/**
 * Zweck: Beschreibt class AppWarenkorbMenuComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    selector: 'app-warenkorb-menu',
    templateUrl: 'app.warenkorb-menu.component.html',
    styleUrls: ['app.warenkorb-menu.component.scss'],
    standalone: false
})
export class AppWarenkorbMenuComponent implements OnInit, OnDestroy {
  wksub: Subscription;
  pwksub: Subscription;
  esub: Subscription;
  warenkoerbe: Warenkorb[];
  addFeedbackActive = false;
  arrivalFeedbackActive = false;
  private feedbackStartTimer: ReturnType<typeof setTimeout>;
  private feedbackEndTimer: ReturnType<typeof setTimeout>;
  private arrivalStartTimer: ReturnType<typeof setTimeout>;
  private arrivalTimer: ReturnType<typeof setTimeout>;

  article_count = 0;

  primary_warenkorb: Warenkorb;

  open = false;
  open2 = false;

  warenkorb_link = '/shop/warenkorb';


  lieferkunde: Lieferkunde;
  lksub: Subscription;

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private svc: AppWarenkorbService, private router: Router, private lksvc: AppLieferkundeService,
              public msvc: AppMobileService, private esvc: AppEventService) {
  }

/**
 * Beschreibt Methode ngOnDestroy und ihren Rückgabevertrag.
 */
  ngOnDestroy(): void {
    if (this.wksub instanceof Subscription) {
      this.wksub.unsubscribe();
    }
    if (this.pwksub instanceof Subscription) {
      this.pwksub.unsubscribe();
    }
    if (this.lksub instanceof Subscription) {
      this.lksub.unsubscribe();
    }
    if (this.esub instanceof Subscription) {
      this.esub.unsubscribe();
    }
    clearTimeout(this.feedbackStartTimer);
    clearTimeout(this.feedbackEndTimer);
    clearTimeout(this.arrivalStartTimer);
    clearTimeout(this.arrivalTimer);
  }

/**
 * Beschreibt Methode navigateTo und ihren Rückgabevertrag.
 */
  navigateTo(url) {
    this.router.navigateByUrl(url);
  }

/**
 * Beschreibt Methode getWarnkorbCount und ihren Rückgabevertrag.
 */
  getWarnkorbCount() {
    if (this.warenkoerbe) {
      return this.warenkoerbe.length;
    } else {
      return 0;
    }
  }

/**
 * Beschreibt Methode getTotalItemCount und ihren Rückgabevertrag.
 */
  getTotalItemCount() {
    let count = 0;

    if (this.warenkoerbe) {
      for (const wk of this.warenkoerbe) {
        count += wk.artikel_count;
      }
    }

    return count;
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    // Das letzte Ereignis aus der BehaviorSubject-Queue ist keine neue Aktion.
    this.esub = this.esvc.getQueue().pipe(skip(1)).subscribe(event => {
      if (event.name == 'gui.warenkorb_article_added') {
        this.showAddFeedback();
      } else if (event.name == 'gui.warenkorb_flight_started') {
        clearTimeout(this.feedbackStartTimer);
        clearTimeout(this.feedbackEndTimer);
        this.addFeedbackActive = false;
      } else if (event.name == 'gui.warenkorb_flight_arrived') {
        this.showArrivalFeedback();
      }
    });
    this.lksub = this.lksvc.current_lieferkunde$.subscribe(lk => this.lieferkunde = lk);
    this.pwksub = this.svc.primary_warenkorb$.subscribe(wk => {
      this.primary_warenkorb = wk;
      if (wk) {
        this.article_count = wk.artikel_count;
      } else {
        this.article_count = 0;
      }
    });
    this.wksub = this.svc.warenkoerbe$.subscribe(wks => {
      this.warenkoerbe = wks;
      if (this.warenkoerbe.length == 1) {
        this.warenkorb_link = '/shop/warenkorb/' + this.warenkoerbe[0].id;
      } else {
        this.warenkorb_link = '/shop/warenkorb';
      }
    });
  }

/**
 * Betont den Navbar-Warenkorb kurz, wenn ein Teil ankommt.
 */
  private showArrivalFeedback(): void {
    clearTimeout(this.arrivalStartTimer);
    clearTimeout(this.arrivalTimer);
    this.arrivalFeedbackActive = false;
    this.arrivalStartTimer = setTimeout(() => {
      this.arrivalFeedbackActive = true;
      this.arrivalTimer = setTimeout(() => this.arrivalFeedbackActive = false, 500);
    }, 0);
  }

/**
 * Startet die Rückmeldung nach jedem erfolgreichen Hinzufügen erneut.
 */
  private showAddFeedback(): void {
    clearTimeout(this.feedbackStartTimer);
    clearTimeout(this.feedbackEndTimer);
    this.addFeedbackActive = false;
    this.feedbackStartTimer = setTimeout(() => {
      this.addFeedbackActive = true;
      this.feedbackEndTimer = setTimeout(() => this.addFeedbackActive = false, 800);
    }, 0);
  }

/**
 * Beschreibt Methode show und ihren Rückgabevertrag.
 */
  show() {
    this.open = true;
  }

/**
 * Beschreibt Methode hide und ihren Rückgabevertrag.
 */
  hide() {
    setTimeout(() => {
      this.open = false;
    }, 300);

  }

/**
 * Beschreibt Methode show2 und ihren Rückgabevertrag.
 */
  show2() {
    this.open2 = true;
  }

/**
 * Beschreibt Methode hide2 und ihren Rückgabevertrag.
 */
  hide2() {
    setTimeout(() => {
      this.open2 = false;
    }, 300);
  }
}
